module.exports = __webpack_public_path__ + "static/media/ic-settings.5a2a055b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-settings.svg
// module id = 665
// module chunks = 14